<div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.VISION_MISSIONtitle' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.add_Vision' | translate }}</p>
          </div>
        </div>

<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="about-section">
    <div class="row">

  <!-- Arabic Card -->
  <div class="col-md-6 col-12">
    <div class="card shadow-sm border-0 rounded-3">
      
      <div class="card-body pt-2">

        <label>{{ 'MENU.DASHBOARD.title_ar' | translate }}</label>
        <input
          class="form-control mt-2"
          [(ngModel)]="about.title_ar"
          placeholder="{{ 'MENU.DASHBOARD.write_title_here' | translate }}"
        />

        <label class="mt-3">{{ 'MENU.DASHBOARD.content_ar' | translate }}</label>
        <textarea
          class="form-control content-textarea mt-2"
          [(ngModel)]="about.content_ar"
          rows="4"
          placeholder="{{ 'MENU.DASHBOARD.write_content_here' | translate }}"
        ></textarea>

      </div>
    </div>
  </div>

  <!-- English Card -->
  <div class="col-md-6 col-12 ">
    <div class="card shadow-sm border-0 rounded-3">
     
      <div class="card-body pt-2">

        <label>{{ 'MENU.DASHBOARD.title_en' | translate }}</label>
        <input
          class="form-control mt-2"
          [(ngModel)]="about.title_en"
          placeholder="{{ 'MENU.DASHBOARD.write_title_here' | translate }}"
        />

        <label class="mt-3">{{ 'MENU.DASHBOARD.content_en' | translate }}</label>
        <textarea
          class="form-control content-textarea mt-2"
          [(ngModel)]="about.content_en"
          rows="4"
          placeholder="{{ 'MENU.DASHBOARD.write_content_here' | translate }}"
        ></textarea>

      </div>
    </div>
  </div>

</div>

      <!-- Save Button -->
      <div class="text-center mt-4">
        <button class="btn btn-primary px-5 py-2 save-btn" (click)="updateAbout()">
          {{ 'MENU.DASHBOARD.save_changes' | translate }}
        </button>
      </div>
    </section>
  </div>
</div>
